import { RepositoryFactory } from '../../api/RepositoryFactory';

const MetasRepository = RepositoryFactory.get('meta');

// initial state
const state = {
    metas: [], // [{ Title, Description, Route }, ... ]
};

// getters
const getters = {
    getMeta: (state, getters, rootState) => (route) => {
        return state.metas.find(meta => meta.fields['Route'] === route);
    }
};

// actions
const actions = {
    async getMetas ({ commit, state }) {
        const { data } = await MetasRepository.findAll();

        commit('setMetas', data.records);
    },
};

// mutations
const mutations = {
    setMetas (state, metas) {
        state.metas = metas;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};